import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {User} from '../../models/user';
import {djangourl} from '../../../assets/urls';
import {isPlatformBrowser} from '@angular/common';

@Injectable({providedIn: 'root'})
export class AuthenticationService {

  private _currentUserSubject: BehaviorSubject<User> = new BehaviorSubject<User>(new User());
  public currentUser: Observable<User> = new BehaviorSubject<User>(new User());

  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this._currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
          this.currentUser = this._currentUserSubject.asObservable();

    }
  }

  public get currentUserValue(): User {
    return this._currentUserSubject.value;
  }

  set currentUserSubject(value) {
    this._currentUserSubject.next(value);
  }

  check() {
    this.http.get(djangourl + 'api/user/').subscribe(result => {
    });
  }

  set_user(user) {
     if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('currentUser', JSON.stringify(user));
        }
        this._currentUserSubject.next(user);
  }

  login(username: string, password: string) {
    return this.http.post<any>(djangourl + `api/token-auth/`, {username, password})
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('currentUser', JSON.stringify(user));
        }
        this._currentUserSubject.next(user);
        return user;
      }));
  }

  logout() {
    // remove user from local storage to log user out
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('currentUser');
    }
    this._currentUserSubject.next(null);
  }
}
